// extracted by mini-css-extract-plugin
export var nav = "Menu-module--nav--8nMmn";
export var menuButton = "Menu-module--menuButton--3wI8P";
export var navigation = "Menu-module--navigation--FSuLU";
export var menuItem = "Menu-module--menu-item--zn-o4";
export var active = "Menu-module--active--2LNla";
export var background = "Menu-module--background--23nyQ";
export var iconPlaceholder = "Menu-module--icon-placeholder--2i1Vk";
export var textPlaceholder = "Menu-module--text-placeholder--2x2bF";
export var refresh = "Menu-module--refresh--cLmid";